import database from '../firebase/firebase';
import {firebase} from '../firebase/firebase';

export const studentTypes = {
    LOAD_PROFILE: "student/GETTING_DATA",
    APPLY: "student/APPLY"
};

export const applyVacancy = (info) => ({
    type: studentTypes.APPLY,
    info
});

export const setProfile = (profile) => ({
    type: studentTypes.LOAD_PROFILE,
    profile
});

export const loadStudentProfile = (uid) => {
    return (dispatch) => {
        return database.collection('users').doc(uid).get().then((snapshot) => {
            let data = snapshot.data();
            dispatch(setProfile(data))
        }).catch((er) => {
            console.log(er)
        })
    }
}
export const startApplyVacancy = (data) => {
    return (dispatch, getState) => {
        const student = getState().student.profile;
        return database.collection(`companies/${data.vacancyOwner}/jobs/${data.jobID}/applicants/`)
        .doc(student.id).set(student, {merge: true}).then(() => {
            const inc = firebase.firestore.FieldValue.increment(1);
            database.collection(`companies/${data.vacancyOwner}/jobs/`).doc(data.jobID)
            .update({applicantsCount: inc}).then(()=>{
                database.collection('vacancies').doc(data.jobID).update({
                    applicantsCount: inc
                })
            })
         }).catch((e) => {
            console.log(e)
        }) 
    }
}